export const URL_ORIGIN = 'https://www.movistar.es';
export const URL_FULL_CONFIG = 'https://www.movistar.es/fibra-y-movil/';
export const URL_LOGIN = 'https://www.movistar.es/auth/login?redirect=';
export const URL_REFRESH = 'https://www.movistar.es/misc/auth/refresh/?redirect=';

export const LOGED_COOKIE = 'seth-session-logged';
export const SOFTLOGED_COOKIE = 'seth-session-softlogged';

export const BACK_OFFICE_CAMPAIGN = 'se_config';

export const LOGIN_TYPES = {
  LOGGED: 'logged',
  SOFTLOGGED: 'softLogged',
};

export const API_STATUS = {
  OK: 'OK',
  KO: 'KO',
  LOADING: 'LOADING',
};

export const SCREEN_TYPES = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
};

export const LAYOUT_TYPES = {
  CONECTIVIDAD: 'conectividad',
  TV: 'tv',
  ALL: 'all',
  RECOMENDATOR: 'recomendator',
  PROMO: 'promo',
};

export const FREE_ZONE_ID = '600001';
export const REGULATED_ZONE_ID = '600000';

export const ZONES_BY_HEADER = {
  FREE: 'ZL',
  REGULATED: 'ZR',
  MIXED: 'ZM',
};

export const ZONES_IDS = {
  [ZONES_BY_HEADER.FREE]: FREE_ZONE_ID,
  [ZONES_BY_HEADER.REGULATED]: REGULATED_ZONE_ID,
  [ZONES_BY_HEADER.MIXED]: FREE_ZONE_ID,
};

export const PARAMS_DICTIONARY = [
  'productOffering',
  'modulos',
  'poLMA',
  'poN',
  'poTV',
  'bonus',
  'shoppingCart',
  'upgradeConnectivity',
  'promoId',
  'show',
  'directBuyProcess',
  'zipCode',
  'bestsellers',
  'reHydrate',
  'Ap_Tcol',
  'directToBuyProcess',
  'insurance',
  'debugServer',
  'enviromentQa',
  'sendRetentionPromo',
  'backOfficeSend',
  'sendCapa',
  'confirmation',
  'rehidratate',
  'includeHiredMobileAddons',
  'fiber',
  'mobileLines',
  'tvChannels',
  'bundles',
  'retentionModules',
  'sam_campaign',
  'openLmModal',
  'compact',
  'speedId',
];

export const PARAMS_DICTIONARY_TO_GO_CONFIG = [
  'productOffering',
  'modulos',
  'poLMA',
  'poN',
  'poTV',
  'bonus',
  'shoppingCart',
  'upgradeConnectivity',
  'promoId',
  'show',
  'directBuyProcess',
  'zipCode',
  'reHydrate',
  'Ap_Tcol',
  'directToBuyProcess',
  'insurance',
  'debugServer',
  'enviromentQa',
  'sendRetentionPromo',
  'backOfficeSend',
  'sendCapa',
  'confirmation',
  'retentionModules',
];

export const DISNEY_ANUNCIOS_ID = '3875';
export const DISNEY_PREMIUM_ID = '3876';

export const FICCION_TOTAL_ID = '1786';

export const PRODUCT_OFFERING_TYPES = {
  PRODUCTS: {
    MIMOVISTAR: {
      ID: '2',
      descrip: 'MODULAR-MI MOVISTAR',
    },
    FUSION: {
      ID: '1',
      descrip: 'FUSION',
    },
    ISR: {
      ID: '3',
      descrip: 'ISR',
    },
    TARIFA_MOVIL: {
      ID: '4',
      descrip: 'TARIFA MOVIL',
    },
    LINEA_INIDIVIDUAL: {
      ID: '5',
      descrip: 'LINEA INIDIVIDUAL',
    },
    TARIFA_PREPAGO: {
      ID: '6',
      descrip: 'TARIFA PREPAGO',
    },
    TELEVISION: {
      ID: '7',
      descrip: 'TELEVISION',
    },
    NETFLIX: {
      ID: '8',
      descrip: 'NETFLIX',
    },
    DISNEY: {
      ID: '9',
      descrip: 'DISNEY',
    },
    TERMINAL_R2R_ADICIONAL: {
      ID: '10',
      descrip: 'TERMINAL R2R ADICIONAL',
    },
    TERMINAL_R2R_INCLUIDO: {
      ID: '11',
      descrip: 'TERMINAL R2R INCLUIDO',
    },
    BAF: {
      ID: '12',
      descrip: 'BANDA ANCHA FIJA (BAF)',
    },
    EHEALTH: {
      ID: '13',
      descrip: 'EHEALTH',
    },
    EQUIPAMIENTO: {
      ID: '14',
      descrip: 'EQUIPAMIENTO',
    },
    CONEXION_SEGURA: {
      ID: '15',
      descrip: 'CONEXION SEGURA',
    },
    OTROS: {
      ID: '16',
      descrip: 'OTROS',
    },
    CONVERGENTE_O2: {
      ID: '17',
      descrip: 'CONVERGENTE O2',
    },
  },
};

export const PURCHASE_PROCESS_KINDS = {
  BACKOFFICE: 'backOffice',
  CAPA: 'capa',
  C2C: 'c2c',
  URL: 'url',
};

export const CONFIRMATION_TYPES = {
  PREVENTION: 'PREVENTION',
  BACKOFFICE: 'BACKOFFICE',
  CAPA: 'CAPA',
  C2C: 'C2C',
  KEEP: 'KEEP',
};

export const CONFIRMATION_STATUS = {
  LOADING: 'LOADING',
  OK: 'OK',
  KO: 'KO',
  REDEEMED: 'REDEEMED',
};

export const COL_APP_OPERATION_SUCCESS = {
  redirect: '/',
  refresh: ['PRODUCTS', 'DEVICES_R2R', 'NOTIFICATIONS'],
};

export const CONFIRMATION_KO_INFO = {
  title: 'No se ha podido realizar la contratación',
  description: 'Inténtalo de nuevo más tarde.<br>Muchas gracias por confiar en Movistar',
}

export const TIPOS_R2R = {
  INCLUIDO: 'incluido',
  ADICIONAL: 'adicional',
  NO_DISPONIBLE: 'no disponible',
};

export const CONECTIVIDAD_BASE_ID = '104-219';
export const BASE_R2R_UPGRADES = ['305','303','304', '99400_1_0', '99400_2_0', '99400_3_0', '99400_1_1', '99400_2_1', '99400_3_1'];
export const CONECTIVIDAD_ESENCIAL = '105-219';
export const CARDS_WIDTH = '286px';

export const DEVICE_SLIDER_INFO = {
  'client-included': {
    title: 'Añade un dispositivo desde 0 €',
    subtitle: 'Puedes añadir a tu pack 1 dispositivo desde 0 € y otros 4 a precios especiales entre un amplio catálogo de',
    linkText: 'móviles, tablets, TVs, portátiles...',
    link: '/moviles/'
  },
  'client-additional': {
    title: 'Añade más dispositivos a tu pack miMovistar',
    subtitle: 'Puedes añadir a tu pack hasta 5 dispositivos a precios especiales entre un amplio catálogo de',
    linkText: 'móviles, tablets, TVs, portátiles...',
    link: '/moviles/'
  },
  'nonClient-included': {
    title: 'Añade un dispositivo desde 0 € cuando tengas instalado tu pack miMovistar',
    subtitle: 'Cuando tengas instalada la fibra, podrás añadir a tu pack 1 dispositivo desde 0 € y otros 4 a precios especiales entre un amplio catálogo de móviles, tablets, Smart TVs , portátiles...',
    linkText: '',
    link: ''
  },
  'nonClient-additional': {
    title: 'Añade hasta 5 dispositivos cuando tengas instalado tu pack miMovistar',
    subtitle: 'Cuando tengas instalada la fibra, podrás añadir a tu pack hasta 5 dispositivos a precios especiales entre un amplio catálogo de móviles, tablets, Smart TVs , portátiles...',
    linkText: '',
    link: ''
  }
};

export const VALID_INPUTS_RECOMEND = {
  fiber: [
    '300',
    '600',
    '1000',
  ],
  mobileLines: [
    '1',
    '2',
    '3',
    '4',
  ],
  tvChannels: [
    '303',
    '304',
    '305',
    '166',
    '1787',
    '200',
    '1786',
    '498_268',
    '498_269',
    '498_3544',
    '3874',
    '3876',
    '3873',
    '3875',
  ],
};

export const MOCK_CONTRIBUCION_CONECTIVIDAD = {
  'cms-component-text-list-1': {
    'cms-text-list-1': [
      {
        'cms-atom-label-1': {
          text: 'Recomendador -- Texto Card Fibra',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-1': {
          text: '1 Gb',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-2': {
          text: 'Recomendador -- Texto Card Líneas móviles',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-2': {
          text: '1 línea ilimitada y 1 línea 5 GB',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-3': {
          text: 'Recomendador -- Texto Card Dispotivo',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-3': {
          text: 'Incluido desde 0 €',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-4': {
          text: 'Configurador -- Titulo Card',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-4': {
          text: 'Fibra 1 Gb, 1 línea ilimitada y 1 línea 5 GB',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-5': {
          text: 'Configurador -- Texto carrito',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-5': {
          text: 'Fibra 1 Gb, 1 línea ilimitada y 1 línea 5 GB',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-2': {
    'cms-text-list-1': [
      {
        'cms-atom-label-1': {
          text: 'Recomendador -- Texto Card Fibra',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-1': {
          text: '1Gb',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-2': {
          text: 'Recomendador -- Texto Card Líneas móviles',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-2': {
          text: '2 líneas ilimitadas',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-3': {
          text: 'Recomendador -- Texto Card Dispositivo',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-3': {
          text: 'Incluido desde 0 €',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-4': {
          text: 'Configurador -- Titulo Card',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-4': {
          text: 'Fibra 1 Gb, 2 líneas móviles ilimitadas',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-5': {
          text: 'Configurador -- Titulo Card',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-5': {
          text: 'Fibra 1 Gb, 2 líneas móviles ilimitadas',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-5': {
          text: 'Configurador -- Titulo Carrito',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-5': {
          text: 'Fibra 1 Gb, 2 líneas móviles ilimitadas',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-3': {
    'cms-text-list-1': [
      {
        'cms-atom-label-1': {
          text: 'Recomendador -- Texto Card Fibra',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-1': {
          text: '',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-2': {
          text: 'Recomendador -- Texto Card Líneas móviles',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-2': {
          text: '',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-3': {
          text: 'Recomendador -- Texto Card Dispotivo',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-3': {
          text: '',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-4': {
          text: 'Configurador -- Titulo Card',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-4': {
          text: 'Fibra 1 Gb, 2 líneas móviles ilimitadas, MultiSIM y otras ventajas',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-label-5': {
          text: 'Configurador -- Titulo Carrito',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
        'cms-atom-text-5': {
          text: 'Fibra 1 Gb, 2 líneas móviles ilimitadas, MultiSIM y otras ventajas',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-4': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-5': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-6': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-7': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-8': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-9': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-10': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
  'cms-component-text-list-11': {
    'cms-text-list-1': [
      {
        'cms-atom-text-1': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-2': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-3': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
      {
        'cms-atom-text-4': {
          text: 'Texto filtro recomendador',
          title: '',
          color: 'GREY6',
          size: 't7',
          kind: 'paragraph',
          fontType: 'font-bold',
          align: 'left',
        },
      },
    ],
  },
};

export const CONTRIBUTION_DICTIONARY_GENERAL = {
  'cms-component-text-list-1':
    'Módulo 100--Fibra 1 Gb, 2 líneas móviles (ilimitada y 5 GB)', // Fibra 1 Gb, 2 líneas móviles (ilimitada y
  'cms-component-text-list-2':
    'Módulo 101--Fibra 1 Gb, 2 líneas móviles ilimitadas', // Fibra 1 Gb, 2 líneas móviles ilimitadas
  'cms-component-text-list-3':
    'Módulo 102--Fibra 1 Gb, 2 líneas móviles ilimitadas, MultiSIM y otras ventajas', // Fibra 1 Gb, 2 líneas móviles ilimitadas
  'cms-component-text-list-4':
    'Módulo 103--Fibra 1 Gb, 4 líneas móviles ilimitadas', // Fibra 1 Gb, 2 líneas móviles ilimitadas
  'cms-component-text-list-5':
    'Módulo 104--Fibra 600 Mb, 2 líneas móviles (60 GB y 5 GB)', // Fibra 1 Gb, 2 líneas móviles ilimitadas
  'cms-component-text-list-6':
    'Módulo 105--Fibra 600 Mb, 2 líneas móviles (60 GB y 5 GB)',
  'cms-component-text-list-7': 'Módulo 3496--Bono de llamadas',
  'cms-component-text-list-8': 'Módulo 1885--Línea Adicional 50 GB',
  'cms-component-text-list-9': 'Módulo 1886--Línea Adicional 100 GB',
  'cms-component-text-list-10': 'Módulo 1887--Línea Adicional Ilimitada',
  'cms-component-text-list-11': 'Módulo 200--Movistar Plus',
  'cms-component-text-list-12': 'Módulo 303--LALIGA',
  'cms-component-text-list-13': 'Módulo 304--Champions',
  'cms-component-text-list-14': 'Módulo 305--Fútbol Total',
  'cms-component-text-list-15': 'Módulo 1787--Deportes Total',
  'cms-component-text-list-16': 'Módulo 166--Motor',
  'cms-component-text-list-17': 'Módulo 16--Adutlos',
  'cms-component-text-list-18': 'Módulo 25--PlayBoy',
  'cms-component-text-list-19': 'Módulo 66--CLASSICA',
  'cms-component-text-list-20': 'Módulo 148--Extra Latino',
  'cms-component-text-list-21': 'Módulo 168--Iberalia',
  'cms-component-text-list-22': 'Módulo 33--Mezzo',
  'cms-component-text-list-23': 'Módulo 99400--Ficción Total',
  'cms-component-text-list-24': 'Módulo 99402--Netflix',
  'cms-component-text-list-25': 'Módulo 99401--Disney+',
  'cms-component-text-list-26': 'Módulo 3802--HBO Max',
  'cms-component-text-list-27': 'Módulo 4054--SkyShowtime',
  'cms-component-text-list-28': 'Módulo Carrito--Configurador',
  'cms-component-text-list-29': 'Módulo Prevención--Configurador',
  'cms-component-text-list-30': 'Módulo C2C--Configurador',
  'cms-component-text-list-31': 'Módulo 201--La liga Addon',
  'cms-component-text-list-32': 'Módulo 651--Champions Addon',
  'cms-component-text-list-33': 'Módulo Modal requiere ir al config completo desde config conectividad ',
  'cms-component-text-list-34': 'Módulo 5848--Baloncesto',
};

export const SHOPPING_CART_FOOTER_LAYOUTS = {
  CONFIG_MOBILE: 'CONFIG_MOBILE',
  CONFIG_MOBILE_FLYOUT: 'CONFIG_MOBILE_FLYOUT',
  MODAL_FICHA_MOBILE: 'MODAL_FICHA_MOBILE',
  MODAL_FICHA_DESKTOP: 'MODAL_FICHA_DESKTOP',
}

export const PUSSUB_STATES_DICTIONARY = {
  INIT: 'CONFIG_FRONT_INITIALIZE_CONFIG',
  INIT_REFRESH_OLD_CONECTIVITY: 'CONFIG_FRONT_REFRESH_OLD_CONECTIVITY',
  PURCHASE: {
    PREVENTION: {
      SHOW: 'CONFIG_FRONT_SHOW_PREVENTION',
      ACEPTED: 'CONFIG_FRONT_PREVENTION_ACEPTED',
      REJECTED: 'CONFIG_FRONT_PREVENTION_REJECTED',
    },
    RETENTION: {
      SHOW: 'CONFIG_FRONT_SHOW_RETENTION',
      ACEPTED: 'CONFIG_FRONT_RETENTION_ACEPTED',
      ALREADY_HIRED: 'CONFIG_FRONT_RETENTION_ALREADY_HIRED',
      REJECTED: 'CONFIG_FRONT_RETENTION_REJECTED',
    },
    PROCESS: {
      PROCESS_TO_GO: 'CONFIG_FRONT_PURCHASE_PROCESS_TO_GO'
    }
  },
  TAPON: 'CONFIG_FRONT_TAPON'
}

export const TAPON_TYPES = {
  CLIENT: {
    '422': {
      img: '/static/images/misc/chica-volando-smartphone.svg',
      title:
        'Lamentablemente, por tus características de cliente no es posible realizar online el cambio solicitado',
      description:
        "Puedes llamarnos GRATIS al <a href='tel:900105351'>900105351</a> y un asesor comercial te lo gestionará personalmente.<br /><br />Gracias por confiar en Movistar.",
      buttonLabel: 'Aceptar',
    },

    ERROR_API: {
      preTitle: '¡Lo sentimos, algo ha ido mal !',
      img: '/static/images/misc/chica-volando-smartphone.svg',
      title: 'En este momento no es posible modificar tu pack online.',
      description:
        "Por favor, inténtalo de nuevo en unos minutos o llama gratis al <a href='tel:900105351'>900105351</a> y un asesor comercial te lo gestionará personalmente.<br /><br />Gracias por confiar en Movistar.",
      buttonLabel: 'Aceptar',
    },

  
    FUSION_SIN_TV_FUTBOL: {
      img: '/static/images/misc/chica-volando-smartphone.svg',
      title: 'No es posible modificar tu pack online',
      description:
        "Para continuar con tu nueva configuración llama gratis al <a href='tel:900201013'>900 20 10 13</a> y un asesor comercial te lo gestionará personalmente.",
      buttonLabel: 'Aceptar',
    },

   
    FUSION_CON_TV_FUTBOL: {
      img: '/static/images/misc/chica-volando-smartphone.svg',
      title: 'Tenemos una oferta exclusiva para ti',
      description:
        "Para continuar con tu nueva configuración llama gratis al <a href='tel:900201013'>900 20 10 13</a> y un asesor comercial te ofrecerá el mejor precio.",
      buttonLabel: 'Aceptar',
    },
  },

  NO_CLIENT: {
    img: '/static/images/misc/chica-volando-smartphone.svg',
    title: 'No es posible realizar online el cambio solicitado.',
    description:
      "Puedes llamarnos GRATIS al <a href='tel:900105351'>900105351</a> y un asesor comercial te lo gestionará personalmente.<br /><br />Gracias por confiar en Movistar.",
    buttonLabel: 'Aceptar',
  },
};
export const COMON_SPEED_ID = '3883'
export const COMON_SPEED_ID_105 = '219'
export const COMON_SPEED_ID_104 = '219'

export const RECOM_VERSION_DICTRIONARY = {
  'digi': 'x=4',
  'vodafone': 'x=2',
  'default': ''
}
